'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

define(['dropdownInputFactory', 'app'], function (dropdownInputFactory, app) {
  var addLabels = function addLabels(choices) {
    if (choices.length <= 0) return [];

    var firstLetter = choices[0].display[0];
    var sameFirstLetterUntilIndex = function () {
      var i = choices.findIndex(function (_ref) {
        var display = _ref.display;
        return display[0].toUpperCase() !== firstLetter.toUpperCase();
      });
      return i <= 0 ? choices.length : i;
    }();

    return [{ type: 'label', display: firstLetter.toUpperCase() }].concat(_toConsumableArray(choices.slice(0, sameFirstLetterUntilIndex)), _toConsumableArray(addLabels(choices.slice(sameFirstLetterUntilIndex))));
  };

  return dropdownInputFactory({
    initialValue: function initialValue(_ref2) {
      var element = _ref2.element;

      var rawChoicesJSON = element.getAttribute('data-choices');
      var rawChoices = JSON.parse(rawChoicesJSON);
      var selectedValue = rawChoices.find(function (choice) {
        return choice.selected === 'true';
      });
      return selectedValue ? selectedValue.display : '';
    },
    getChoices: function getChoices(inputValueSoFar, _ref3) {
      var element = _ref3.element;

      var rawChoicesJSON = element.getAttribute('data-choices');
      var rawChoices = JSON.parse(rawChoicesJSON);
      rawChoices.sort(function (choice1, choice2) {
        return choice1.display.localeCompare(choice2.display);
      });
      var choices = rawChoices.filter(function (_ref4) {
        var display = _ref4.display;
        return display !== "" && display.toLowerCase().includes(inputValueSoFar.toLowerCase());
      }).map(function (_ref5) {
        var display = _ref5.display,
            value = _ref5.value;
        return { type: 'choice', display: display, value: value };
      });
      return inputValueSoFar.length <= 0 ? addLabels(choices) : choices;
    }
  });
});
//# sourceMappingURL=simpleDropdownInput.js.map
